import { render } from "./HeroiconsOutlineMinus.vue?vue&type=template&id=6533d24c"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMinus.vue"]])

export default __exports__